<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/affiliate/affiliateList")
          i.fas.fa-user-tie
          span.ml-1 {{ $t("ui.affiliate_list") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.row
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')")
                div.row.col-md-9.mb-1
                  div(width="80%").mr-3
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="search_id") {{ $t("ui.account_id") }}
                      b-form-radio(value="affiliate_code") {{ $t("ui.affiliate_code") }}
                      b-form-radio(value="contact_phone") {{ $t("ui.contact_phone") }}
                  div(width="20%")
                    SubmitButton(
                      :loading="loading"
                      icon="fa fa-search"
                      :text="$t('ui.search')"
                      type="button"
                      @click="getListing()"
                      variant="success"
                      size="sm"
                      )
        div.card-body
          div.mb-1
            div.row
              div.col-md-12
                b-breadcrumb
                  b-breadcrumb-item(
                    @click="drillIn('company')"
                  )
                    span {{ currentUser }}
                  b-breadcrumb-item(
                    v-for="(item,index) in lines"
                    :key="index"
                    :text="item.account_id"
                    :class="{ active: index==lines.length-1 }"
                    @click="drillIn(item)"
                  )
          div.mb-1
            div.card.card-accent-info
              div.card-header
                i.fas.fa-user-tie
                span.font-weight-bold(:title="$t('ui.affiliate')") {{ $t("ui.affiliate") }}
                //- span.badge.badge-info.float-right {{ currentMonth }}
              div.card-body
                div.mb-1
                  div.row.mb-1
                    div.col-md-10
                      b-pagination.float-left(
                        size="sm"
                        hide-ellipsis
                        :total-rows="totalRowAff"
                        :per-page="getPageSize"
                        v-model="currentPageAff"
                        @input="changedPageAff($event)").mb-1
                    div.col-md-2
                      b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                        b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeAff")
                div.row.clusterize
                  div.col-md-12
                    .clusterize-scroll
                      table.tablex(style="width: 100%;")
                        thead
                          tr
                            th.sticky-position(width="3%")
                              span #
                            th.sticky-position.sortable(width="7%" @click="sortOrder('account_id','aff')")
                              span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                              i(:class="changeSortKey('account_id','aff')")
                            th.sticky-position.sortable(@click="sortOrder('full_name','aff')" width="6%")
                              span(:title="$t('ui.full_name')") {{ $t("ui.full_name") }}
                              i(:class="changeSortKey('full_name','aff')")
                            th.sticky-position(width="6%" @click="sortOrder('contact_phone','aff')")
                              span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                              i(:class="changeSortKey('contact_phone','aff')")
                            th.sticky-position(width="5%" @click="sortOrder('signup_ip','aff')")
                              span(:title="$t('ui.signup_ip')") {{ $t("ui.signup_ip") }}
                              i(:class="changeSortKey('signup_ip','aff')")
                            th.sticky-position(width="6%" @click="sortOrder('affiliate_code','aff')")
                              span(:title="$t('ui.affiliate_code')") {{ $t("ui.affiliate_code") }}
                              i(:class="changeSortKey('affiliate_code','aff')")
                            th.sticky-position(width="5%" @click="sortOrder('status','aff')")
                              span(:title="$t('ui.status')") {{ $t("ui.status") }}
                              i(:class="changeSortKey('status','aff')")
                            th.text-center.sticky-position(width="10%" v-if="showActionColumn()")
                              span(:title="$t('ui.action')") {{ $t("ui.action") }}
                            th.sticky-position(width="5%" @click="sortOrder('approved_by','aff')")
                              span(:title="$t('ui.approved_by')") {{ $t("ui.approved_by") }}
                              i(:class="changeSortKey('approved_by','aff')")
                            th.text-right.sticky-position.sortable(width="7%" @click="sortOrder('approved_date','aff')")
                              span(:title="$t('ui.approved_date')") {{ $t("ui.approved_date") }}
                              i(:class="changeSortKey('approved_date','aff')")
                            th.text-right.sticky-position.sortable(width="7%" @click="sortOrder('created_date','aff')")
                              span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                              i(:class="changeSortKey('created_date','aff')")
                        tbody.clusterize-content
                          tr(v-if="affiliateList.length == 0")
                            td(:colspan="showActionColumn() == true ? '11' : '10'").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in affiliateList" :class="$helpers.rowClass(item)")
                            td
                              span(:title="((currentPageAff - 1) * getPageSize + index + 1)") {{ ((currentPageAff - 1) * getPageSize + index + 1) }}
                            td
                              span(:title="item.account_id")
                                b-link.clickable(href="javascript:void(0);" @click="drillIn(item)") {{ item.account_id }}
                            td
                              span(:title="item.full_name") {{ item.full_name }}
                            td
                              span(:title="item.contact_phone") {{ item.contact_phone }}
                            td
                              span(:title="item.signup_ip") {{ item.signup_ip }}
                            td
                              span(:title="item.affiliate_code") {{ item.affiliate_code }}
                            td
                              span(v-if="item.status.toUpperCase() == 'FREEZE' || !showActionButton('updatestatusaff')" :title="item.status") {{ item.status }}
                              select(@change="changedAffiliateStatus(item, $event)" :value="item.status" v-else)
                                option(value="ACTIVE") {{ $t("ui.active") }}
                                option(value="BLOCK" v-if="item.status.toUpperCase() == 'BLOCK'") {{ $t("ui.block") }}
                                option(value="CLOSE") {{ $t("ui.close") }}
                                option(value="SUSPEND") {{ $t("ui.suspend") }}
                            td.actions(v-if="showActionColumn()")
                              span(v-if="item.account_type == 1 && showActionButton('editaff')")
                                a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onEditAffiliate(item)" :title="$t('ui.edit')")
                              span(v-if="item.account_type == 1 && showActionButton('updatesettlementtypeaff')")
                                a.fa.fa-money-bill-alt.text-success(href="javascript:void(0)" @click="onUpdateSettlementTypeAffiliate(item)" :title="$t('ui.update_settlement_type')")
                              span(v-if="item.account_type == 1 && showActionButton('updatecarryoveraff')")
                                a.fas.fa-exchange-alt.text-danger(href="javascript:void(0)" @click="onUpdateCarryOverAffiliate(item)" :title="$t('ui.update_carry_over')")
                              span(v-if="showActionButton('walletadjustaff')")
                                a.fa.fa-sliders-h.text-secondary(href="javascript:void(0)" @click="onAdjustAffiliate(item)" :title="$t('ui.wallet_adjust')")
                              span(v-if="showActionButton('updatecomissionaff')")
                                a.fas.fa-cubes.text-info(href="javascript:void(0)" @click="onUpdateCommAffiliate(item)" :title="$t('ui.update_comm')")
                              span(v-if="showActionButton('resetpasswordaff')")
                                a.fa.fa-lock.text-warning(href="javascript:void(0)" @click="onResetPasswordAffiliate(item)" :title="$t('ui.reset_password')")
                              span(v-if="item.account_type != 1 && showActionButton('moveaff')")
                                a.fas.fa-people-carry.text-info(href="javascript:void(0)" @click="onMoveAffiliate(item)" :title="$t('ui.move')")
                              //- span
                              //-   a.fa.fa-user.text-success(href="javascript:void(0)" @click="onSubAccDetailAffiliate(item)" :title="$t('ui.sub_account_detail')")
                              span(v-if="item.profile_status.toUpperCase() == 'BLOCK' && showActionButton('unblockaff')")
                                a.fa.fa-unlock.text-danger(href="javascript:void(0)" @click="onUnblockAffiliate(item)" :title="$t('ui.unblock')")
                            td
                              span(:title="item.approved_by") {{ item.approved_by }}
                            td.text-right
                              span(:title="$moment(item.approved_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.approved_date") {{ $moment(item.approved_date).format('YYYY-MM-DD, HH:mm:ss') }}
                            td.text-right
                              span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.created_date") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
          div.mb-1
            div.card.card-accent-success
              div.card-header
                i.fa.fa-user
                span.font-weight-bold(:title="$t('ui.member')") {{ $t("ui.member") }}
              div.card-body
                div.mb-1
                  div.row.mb-1
                    div.col-md-10
                      b-pagination.float-left(
                        size="sm"
                        hide-ellipsis
                        :total-rows="totalRowMbm"
                        :per-page="getPageSize"
                        v-model="currentPageMbm"
                        @input="changedPageMbm($event)").mb-1
                    div.col-md-2
                      b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                        b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeMbm")
                div.row.clusterize
                  div.col-md-12
                    .clusterize-scroll
                      table.tablex(style="width: 100%;")
                        thead
                          tr
                            th.sticky-position(width="3%")
                              span #
                            th.sticky-position.sortable(width="7%" @click="sortOrder('account_id','mbm')")
                              span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                              i(:class="changeSortKey('account_id','mbm')")
                            th.sticky-position(width="6%" @click="sortOrder('contact_phone','mbm')")
                              span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                              i(:class="changeSortKey('contact_phone','mbm')")
                            th.sticky-position(width="5%" @click="sortOrder('signup_ip','mbm')")
                              span(:title="$t('ui.signup_ip')") {{ $t("ui.signup_ip") }}
                              i(:class="changeSortKey('signup_ip','mbm')")
                            th.sticky-position.text-center(width="6%")
                              span(:title="$t('ui.account_verified')") {{ $t("ui.account_verified") }}
                            th.sticky-position.text-right(width="5%" @click="sortOrder('verified_date','mbm')")
                              span(:title="$t('ui.verified_date')") {{ $t("ui.verified_date") }}
                              i(:class="changeSortKey('verified_date','mbm')")
                            th.text-right.sticky-position.sortable(width="7%" @click="sortOrder('created_date','mbm')")
                              span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                              i(:class="changeSortKey('created_date','mbm')")
                        tbody.clusterize-content
                          tr(v-if="memberList.length == 0")
                            td(colspan="7").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in memberList")
                            td
                              span(:title="((currentPageMbm - 1) * getPageSize + index + 1)") {{ ((currentPageMbm - 1) * getPageSize + index + 1) }}
                            td
                              span.font-weight-bold(:title="item.account_id")
                                b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.account_id }}
                            td
                              span(:title="item.contact_phone") {{ item.contact_phone }}
                            td
                              span(:title="item.signup_ip") {{ item.signup_ip }}
                            td.text-center
                              span
                                i(:class="{'fas fa-check text-info': item.account_verified, 'fas fa-times text-warning': !item.account_verified  }")
                            td.text-right
                              span(:title="$moment(item.verified_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.verified_date") {{ $moment(item.verified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                            td.text-right
                              span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.created_date") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

    editaffiliate(ref="editaffiliate" :item="editSelectedAffiliate" @clicked="afterEditAffiliate" @failed="handleFailed")
    resetpasswordaffiliate(ref="resetpasswordaffiliate" :item="editSelectedAffiliate" @clicked="afterResetPasswordAffiliate" @failed="handleFailed")
    walletadjustaffiliate(ref="walletadjustaffiliate" :item="editSelectedAffiliate" @clicked="afterWalletAdjustAffiliate" @failed="handleFailed")
    updatecommaffiliate(ref="updatecommaffiliate" :item="editSelectedAffiliate" @clicked="afterUpdateCommAffiliate" @failed="handleFailed")
    updatesettlementtypeaffiliate(ref="updatesettlementtypeaffiliate" :item="editSelectedAffiliate" @clicked="afterUpdateSettlementTypeAffiliate" @failed="handleFailed")
    updatecarryoveraffiliate(ref="updatecarryoveraffiliate" :item="editSelectedAffiliate" @clicked="afterUpdateCarryOverAffiliate" @failed="handleFailed")
    memberdetails(ref="memberdetails" :memberId="editSelectedMemberId" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editaffiliate from "@/components/affiliate/editAffiliate.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import resetpasswordaffiliate from "@/components/affiliate/resetPasswordAffiliate.vue";
import walletadjustaffiliate from "@/components/affiliate/walletAdjustAffiliate.vue";
import updatecommaffiliate from "@/components/affiliate/updateCommAffiliate.vue";
import updatesettlementtypeaffiliate from "@/components/affiliate/updateSettlementTypeAffiliate.vue";
import updatecarryoveraffiliate from "@/components/affiliate/updateCarryOverAffiliate.vue";
import memberdetails from "@/components/member/memberDetails.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editaffiliate,
    resetpasswordaffiliate,
    walletadjustaffiliate,
    updatecommaffiliate,
    updatesettlementtypeaffiliate,
    updatecarryoveraffiliate,
    memberdetails
  },
  data: () => ({
    loading: false,
    affiliateList: [],
    memberList: [],
    lines: [],
    currentPageAff: 1,
    totalRowAff: 0,
    currentPageMbm: 1,
    totalRowMbm: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedAffiliate: null,
    sortKeyAff: "account_id",
    sortTypeAff: "asc",
    sortKeyMbm: "account_id",
    sortTypeMbm: "asc",
    filterBy: "search_id",
    selectedID: "",
    selectedType: "",
    editSelectedMemberId: ""
  }),
  computed: {
    currentUser() {
      return this.$store.getters.accountId;
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
    this.getAffiliateList(true);
  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    showActionColumn() {
      return this.showActionButton('editaff') || this.showActionButton('updatesettlementtypeaff') || this.showActionButton('updatecarryoveraff')
              || this.showActionButton('walletadjustaff') || this.showActionButton('updatecomissionaff') || this.showActionButton('moveaff')
              || this.showActionButton('resetpasswordaff') || this.showActionButton('unblockaff')
    },
    sortOrder(key, type) {
      if (type == 'aff') {
        if (this.sortKeyAff == key)
          this.sortTypeAff = this.sortTypeAff == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyAff = key;
          this.sortTypeAff = 'asc';
        }

        this.getAffiliateList(true);
      } else if (type == 'mbm') {
        if (this.sortKeyMbm == key)
          this.sortTypeMbm = this.sortTypeMbm == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyMbm = key;
          this.sortTypeMbm = 'asc';
        }

        this.getMemberList(true);
      }
    },
    changeSortKey(key, type) {
      if (type == 'aff') {
        if (this.sortKeyAff != key)
          return 'fas fa-sort';
        else if (this.sortKeyAff == key && this.sortTypeAff == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyAff == key && this.sortTypeAff == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'mbm') {
        if (this.sortKeyMbm != key)
          return 'fas fa-sort';
        else if (this.sortKeyMbm == key && this.sortTypeMbm == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyMbm == key && this.sortTypeMbm == 'desc')
          return 'fa fa-sort-down';
      }
    },
    drillIn: function (item) {
      this.search = ""
      this.selectedID = (item == 'company') ? "" : item.account_id
      this.selectedType = item.account_type
      this.getListing();
    },
    onMoveAffiliate: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.move_affiliate_confirm", { name: item.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmMove(item);
          }
        });
    },
    confirmMove: function(item) {
      let url = config.accountMoveAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: item.account_id,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getAffiliateList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getListing() {
      this.getAffiliateList(true);
      this.getMemberList(true);
    },
    onInfo(e) {
      this.editSelectedMemberId = e.account_id;
      this.$refs.memberdetails.$refs.memberDetails.show();
    },
    onResetPasswordAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.resetpasswordaffiliate.$refs.resetPasswordAffiliate.show();
    },
    onEditAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.editaffiliate.$refs.editAffiliate.show();
    },
    onAdjustAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.walletadjustaffiliate.$refs.walletAdjustAffiliate.show();
    },
    onUpdateCommAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.updatecommaffiliate.$refs.updateCommAffiliate.show();
    },
    onSubAccDetailAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.subaccdetailaffiliate.$refs.subAccDetailAffiliate.show();
    },
    onUpdateSettlementTypeAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.updatesettlementtypeaffiliate.$refs.updateSettlementTypeAffiliate.show();
    },
    onUpdateCarryOverAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.updatecarryoveraffiliate.$refs.updateCarryOverAffiliate.show();
    },
    getAffiliateList: function(isSearch) {
      let url = config.accountListAffUrl();

      if (isSearch) this.currentPageAff = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        target_account_id: this.selectedID,
        account_status: null,
        sort_key: this.sortKeyAff,
        sort_type: this.sortTypeAff,
        page_number: this.currentPageAff,
        page_size: this.getPageSize,
      };

      if (this.search.trim() != '') {
        if (this.filterBy == "search_id") {
          json.search_id = this.search.trim();
        } else if (this.filterBy == "affiliate_code") {
          json.affiliate_code = this.search.trim();
        } else if (this.filterBy == "contact_phone") {
          json.contact_phone = this.search.trim();
        }
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.affiliateList = response.data.ds.list;
                if (response.data.ds.line.length > 0) {
                  this.lines = response.data.ds.line.sort(function(a, b) {
                    return a.account_type - b.account_type;
                  });
                }
                else
                  this.lines = [];
                
                this.totalRowAff = this.affiliateList.length > 0 ? this.affiliateList[0].totalrows : 0;
              } else {
                // this.clearTotal()
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getMemberList: function(isSearch) {
      let url = config.memberListAffUrl();

      if (isSearch) this.currentPageMbm = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.selectedID == "" ? this.$store.getters.accountId : this.selectedID,
        sort_key: this.sortKeyMbm,
        sort_type: this.sortTypeMbm,
        page_number: this.currentPageMbm,
        page_size: this.getPageSize,
      };

      if (this.search.trim() != '') {
        json.search_id = this.search.trim();
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.memberList = response.data.dt;
                this.totalRowMbm = this.memberList.length > 0 ? this.memberList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onUnblockAffiliate: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.unblock"),
          text: this.$t("message.unblock_affiliate_confirm", { name: item.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmUnblockAffiliate(item);
          }
        });
    },
    confirmUnblockAffiliate: function(item) {
      let url = config.accountProfileUnblockAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        login_id: item.account_id,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getAffiliateList();
                this.$helpers.showDialog(this.$t("ui.unblock_affiliate"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedAffiliateStatus: function(affiliate, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_affiliate_status_confirm", { name: affiliate.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmAffiliateStatus(affiliate, eventStatus.srcElement.value);
          } else {
            eventStatus.srcElement.value = affiliate.status;
          }
        });
    },
    confirmAffiliateStatus: function(affiliate, status) {
      let url = config.accountStatusUpdateAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: affiliate.account_id,
        new_status: status,
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getAffiliateList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    afterResetPasswordAffiliate: function() {
      this.getAffiliateList();
      this.$helpers.showDialog(this.$t("ui.combine.reset_password"), this.$t("message.success"), "success");
    },
    afterEditAffiliate: function() {
      this.getAffiliateList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_affiliate"), this.$t("message.success"), "success");
    },
    afterWalletAdjustAffiliate: function() {
      this.getAffiliateList();
      this.$helpers.showDialog(this.$t("ui.combine.wallet_adjust"), this.$t("message.success"), "success");
    },
    afterUpdateCommAffiliate: function() {
      this.getAffiliateList();
      this.$helpers.showDialog(this.$t("ui.combine.update_comm"), this.$t("message.success"), "success");
    },
    afterUpdateSettlementTypeAffiliate: function() {
      this.getAffiliateList();
      this.$helpers.showDialog(this.$t("ui.combine.update_settlement_type"), this.$t("message.success"), "success");
    },
    afterUpdateCarryOverAffiliate: function() {
      this.getAffiliateList();
      this.$helpers.showDialog(this.$t("ui.combine.update_carry_over"), this.$t("message.success"), "success");
    },
    changedPageSizeAff: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageAff = 1;
      this.getAffiliateList(true);
    },
    changedPageAff: function(pageNo) {
      this.currentPageAff = pageNo;
      this.getAffiliateList();
    },
    changedPageSizeMbm: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageMbm = 1;
      this.getMemberList(true);
    },
    changedPageMbm: function(pageNo) {
      this.currentPageMbm = pageNo;
      this.getMemberList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>